import '../Donate/Donate.css';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { questionFailCount } from '../Helpers/FormHelper';

export function FormButtonControl({ handleSubmit, inputErrors, questions, waiting }) {

  const backButton = () => {
    return (
      <div className="col-sm-6 text-start">
        <Link to={{ pathname: "/" }}
          className="btn blm-btn-primary">
          <FontAwesomeIcon icon="angle-double-left" />  Previous</Link>
      </div>);
  }

  const spinner = () => {
    if (waiting) {
      return (<FontAwesomeIcon icon="spinner" pulse />);
    } else {
      return null;
    }
  }

  return (
    <div className="row">
      {backButton()}
      <div className="col-sm-6 text-end">
        <Link to="#" onClick={(e) => handleSubmit(e)} className={`btn blm-btn-primary right ${questionFailCount(questions) > 0 || inputErrors() > 0 || waiting ? "disabled" : ""}`}>
          Submit Payment {spinner()}
        </Link>
      </div>
    </div>
  );

}

FormButtonControl.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  inputErrors: PropTypes.func.isRequired,
  questions: PropTypes.array.isRequired,
  waiting: PropTypes.bool,
}

